export const DownloadURL = {
  attachDocumentURL:"https://sfcsblobstorageeastus2.file.core.windows.net/scanneddocumentfs/",
  attachDocumentTokenString:`?sv=2021-06-08&ss=bfqt&srt=sco&sp=rwdlacupiyx&se=2025-01-02T20:19:54Z&st=2023-01-02T12:19:54Z&spr=https&sig=Wzirza9MFV5aGo7Y274fWidVYYXkKMgBLuF7CazxKsU%3D`,
  url: `https://sfcsblobstorageeastus2.file.core.windows.net/fmw-pdfreports/`,
  tokenString:
    `?sv=2021-04-10&st=2022-08-05T07%3A35%3A27Z&se=2031-01-05T09%3A50%3A00Z&sr=s&sp=rcwl&sig=UqXpvCY%2FrnSMpi9p9tO7q4Mk0nyjj2hWovNSedqtU%2F8%3D&xyz`,
};
